import customDataProvider from "./data/customDataProvider";

const dataProvider = customDataProvider();

export default dataProvider;
